import React, { useEffect, useState } from "react";
import Headar from "../Component/Headar";
import { Container, Row, Col } from "react-bootstrap";
import BannerSection from "../Component/BannerSection";
import "../Css/AboutUsSection.css";
import FounderSection from "../Component/FounderSection";
import Service from "../Component/Service";
import SucessStoryImg from "../aseets/img/vince-fleming.png"
import ShapeStory from "../aseets/img/vinceTextImt.png"
import SucessStory from "../Component/SucessStory";
import MemberShip from "../Component/MemberShip";
import WhyChusUS from "../Component/WhyChusUS";
import PlatinumFamily from "../Component/PlatinumFamily";
import Footer from "../Component/Footer";
import MobileHader from "../Component/MobileHader";
import { InfinitySpin } from "react-loader-spinner";
import AboutSection from "../Component/AboutSection";
const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate a delay of 2 seconds (adjust as needed)
    const delay = 1000;
    setTimeout(() => {
      setIsLoading(false);
    }, delay);
  }, []);
  return (
    <React.Fragment>
         {isLoading ? (
        // Loader component while loading
        <div className="loader-container">
          <InfinitySpin
            color="#000"
            height={50}
          width="200"
            timeout={0} // 0 means no timeout, loader will be displayed until setIsLoading(false) is called
          />
        </div>
      ) : (
      <div>
      <Headar />
      <MobileHader />
      <BannerSection />
      {/* about us section ====> */}

     <AboutSection/>
      {/* //// founder section =====> */}
      <FounderSection />
      {/* //// service section =====>  */}
      {/* <Service /> */}
       {/* ///// sucesss story ====> */}
      {/* <div className="sucessBackgroundImg">
        
        <div>
        <div className="storyShapeDiv">
          <img className="shapStoryImg" src={ShapeStory} alt="img" />
        </div>
        </div>
        
      </div> */}
    
      <SucessStory />
 {/* ////// membershipe =====> */}
 <MemberShip />
 {/* ////// why chus us =====> */}
 <WhyChusUS />
 {/* ////// platinum family ===> */}
<PlatinumFamily />
{/* ////  footer ====>  */}
<Footer />
</div>
  )}
    </React.Fragment>
  );
};

export default Home;
